import Button from '@strava/ui/Button';
import React from 'react';
import I18n from 'utils/I18n';
import { trackV2 } from 'utils/analytics';
import StravaLogo from '@strava/ui/StravaLogo';
import styles from './Header.scss';

const Header = () => {
  const handleLoginBtnClick = () => {
    trackV2({
      category: 'onboarding',
      page: 'home',
      action: 'click',
      element: 'login_btn',
      properties: {
        source: 'v2'
      }
    });
    window.location.href = '/login';
  };

  return (
    <div className={styles.container}>
      <StravaLogo alt="Strava" width={95} height={20} />
      <Button
        className={styles.loginBtn}
        type="button"
        onClick={handleLoginBtnClick}
        data-cy="login_btn"
      >
        {I18n.t('components.landing_page.header.login')}
      </Button>
    </div>
  );
};

export default Header;
